import React, { PropsWithChildren } from 'react'

interface Props extends PropsWithChildren {
}

export const MainContent = ({children}: Props) => {
  return <main className="content">{children}</main>
}